import { render, staticRenderFns } from "./PersonalPageCpnCard.vue?vue&type=template&id=4b4a5a1d&scoped=true&"
import script from "./PersonalPageCpnCard.vue?vue&type=script&lang=js&"
export * from "./PersonalPageCpnCard.vue?vue&type=script&lang=js&"
import style0 from "./PersonalPageCpnCard.vue?vue&type=style&index=0&id=4b4a5a1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4a5a1d",
  null
  
)

export default component.exports